import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { colors } from "../../utils/theme";

export const PrimaryLinkButton = ({ link, text, style }) => {
  return (
    <PrimaryLink to={link} style={{ ...style }}>
      {text}
    </PrimaryLink>
  );
};

export const SecondaryLinkButton = ({ link, text, style }) => {
  return (
    <SecondaryLink to={link} style={{ ...style }}>
      {text}
    </SecondaryLink>
  );
};

export const PrimaryDivButton = ({ children, style }) => {
  return (
    <PrimaryDiv style={{ ...style }} as={"div"}>
      {children}
    </PrimaryDiv>
  );
};

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  border-radius: 6px;
  border: 1px solid;
  font-size: 14px;
  line-height: 1.2;
  transition: all 0.3s ease;
  text-align: center;
`;

const PrimaryLink = styled(StyledLink)`
  background-color: ${colors.primary};
  border-color: transparent;
  color: ${colors.textDarkMode};

  &:hover {
    background-color: ${colors.primaryHover};
    color: ${colors.textDarkMode};
  }

  &:focus,
  &:focus-visible {
    color: ${colors.textDarkMode};
  }
`;

const SecondaryLink = styled(StyledLink)`
  background-color: #ffffff;
  border-color: ${colors.primary};
  color: ${colors.primary};

  &:hover {
    color: ${colors.primaryHover};
    border-color: ${colors.primaryHover};
  }
`;

const PrimaryDiv = styled(PrimaryLink)`
  padding: 6px 15px;
  gap: 6px;
`;
